import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-flex-column p-flex-sm-row" }
const _hoisted_2 = {
  key: 0,
  class: "p-float-label p-input-icon-left"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "filled"
}, "Cerca...", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Nessun elemento trovato. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Caricamento in corso... ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 p-text-bold" }, "Filtra per ruolo", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loading && !_ctx.users && _ctx.firstLoading)
    ? (_openBlock(), _createBlock(_component_TableSkeleton, {
        key: 0,
        rows: 10,
        columns: 5
      }))
    : (_openBlock(), _createBlock(_component_DataTable, {
        key: 1,
        ref: "dt",
        value: _ctx.users,
        lazy: true,
        loading: _ctx.loading,
        rows: 10,
        "rows-per-page-options": [10, 20, 50, 100],
        paginator: true,
        totalRecords: _ctx.totalRecords,
        "auto-layout": "",
        "striped-rows": "",
        responsiveLayout: "scroll",
        filterDisplay: "menu",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
        compareSelectionBy: "equals",
        stateStorage: "session",
        stateKey: _ctx.stateKey,
        onPage: _ctx.onPage,
        onSort: _ctx.onSort,
        onRowClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onRowClick($event.data)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-filter-slash",
              label: "Reset",
              class: "p-button-outlined",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClearFilter()))
            }),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onGlobalFilterSubmit && _ctx.onGlobalFilterSubmit(...args)), ["prevent"])),
              class: "p-fluid"
            }, [
              (_ctx.filters.global)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_InputText, {
                      id: "search",
                      modelValue: _ctx.filters.global.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.global.value = $event)),
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"]),
                    _hoisted_4
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ]),
        empty: _withCtx(() => [
          _hoisted_5
        ]),
        loading: _withCtx(() => [
          _hoisted_6
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterableColumns, (fc) => {
            return (_openBlock(), _createBlock(_component_Column, {
              key: fc.field,
              field: fc.field,
              header: fc.header,
              sortable: true,
              showFilterMatchModes: false,
              showFilterOperator: false
            }, {
              filter: _withCtx(({filterModel, filterCallback}) => [
                _createVNode(_component_InputText, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                  placeholder: fc.placeHolder,
                  onKeyup: _withKeys(($event: any) => {filterCallback(); _ctx.onApplyFilter();}, ["enter"])
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onKeyup"])
              ]),
              filterclear: _withCtx(({filterCallback}) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  class: "p-button-outlined",
                  onClick: ($event: any) => {filterCallback(); _ctx.onClearFilter();}
                }, null, 8, ["onClick"])
              ]),
              filterapply: _withCtx(({filterCallback}) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-check",
                  label: "Applica",
                  class: "p-button-success",
                  onClick: ($event: any) => {filterCallback(); _ctx.onApplyFilter()}
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["field", "header"]))
          }), 128)),
          _createVNode(_component_Column, {
            field: "role",
            header: "Ruolo",
            showFilterMatchModes: false,
            showFilterOperator: false
          }, {
            body: _withCtx(({data}) => [
              (data.role)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`user-badge role-${data.role}`)
                  }, _toDisplayString(_ctx.$t(`role.${data.role}`)), 3))
                : _createCommentVNode("", true)
            ]),
            filter: _withCtx(({filterModel}) => [
              _hoisted_7,
              _createVNode(_component_MultiSelect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                options: _ctx.roleOptions,
                placeholder: "Seleziona ruoli",
                class: "p-column-filter",
                optionLabel: "label",
                "option-value": "value"
              }, {
                option: _withCtx(({option}) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(`user-badge role-${option.value}`)
                  }, _toDisplayString(_ctx.$t(`role.${option.value}`)), 3)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
            ]),
            filterclear: _withCtx(({filterCallback}) => [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-times",
                class: "p-button-outlined",
                onClick: ($event: any) => {filterCallback(); _ctx.onClearFilter();}
              }, null, 8, ["onClick"])
            ]),
            filterapply: _withCtx(({filterCallback}) => [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-check",
                label: "Applica",
                class: "p-button-success",
                onClick: ($event: any) => {filterCallback(); _ctx.onApplyFilter()}
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "is_active",
            header: "Stato"
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputSwitch, {
                disabled: "",
                modelValue: data.is_active
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Azioni",
            class: "column-header-right p-text-right",
            style: {"min-width":"100px","width":"150px"}
          }, {
            body: _withCtx(({data}) => [
              _withDirectives(_createVNode(_component_Button, {
                class: "p-button-warning p-mr-1",
                icon: "pi pi-pencil",
                onClick: _withModifiers(($event: any) => (_ctx.onEdit(data)), ["stop"])
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('edit'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              _withDirectives(_createVNode(_component_Button, {
                class: "p-button-danger",
                icon: "pi pi-trash",
                onClick: _withModifiers(($event: any) => (_ctx.onDelete(data)), ["stop"])
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('delete'),
                  void 0,
                  { bottom: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading", "totalRecords", "filters", "stateKey", "onPage", "onSort"]))
}